module.exports = __webpack_public_path__ + "u6.no2.2474893e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/u6.no2.jpg
// module id = rUjB
// module chunks = 0